// Copyright (c) 2017 Deere & Company

import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetProduct = state =>
    ProductSearchResult.update(state, {
        $set: getDefaultState().product
    });

const updateProduct = (state, action) =>
    ProductSearchResult.update(state, {
        $set: action.product
    });

export default (state = getDefaultState().product, action) => {

    const actionTypes = {
        [actions.RESET_PRODUCTS_BY_CUSTOMER_PRODUCT]: resetProduct,
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_PRODUCT]: updateProduct
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/product.js